// export const BASE_PRO = "https://net-movie-backend.vercel.app/api";
// http://localhost:3001/api
export const BASE_PRO = "https://net-movie-backend.vercel.app/api";




